import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      paddingTop: 40,
    },
  },
  { name: 'StaticSymbols' },
);
